import classes from "./Record.module.css"
import {Divider} from "@mui/material";

const Record = (props) => {
    const update_delete_handler = (e) => {
        e.stopPropagation(); // Prevent event bubbling to parent Device
        props.update(props.object);
    }

    return (
        <div 
            className={`${classes.main} ${props.isOverlap ? classes.overlap : ''} ${props.isRunning ? classes.running : ''}`} 
            onClick={update_delete_handler}
        >
            {props.isRunning && (
                <div className={classes.runningBadge}>
                    <span>●</span> 
                </div>
            )}
            <label className={classes.time}>{props.timeslot}</label>
            <Divider orientation="horizontal" variant="middle" flexItem/>
            <div className={classes.cont}>
                <label>{props.description}</label>
            </div>
        </div>
    );
}

export default Record